import PropTypes from 'prop-types';
import recipientPropType from './recipientPropType';

const notificationGroupPropType = PropTypes.shape({
  id: PropTypes.number,
  subscriptionId: PropTypes.number,
  name: PropTypes.string,
  isSuspended: PropTypes.bool,
  recipients: PropTypes.arrayOf(PropTypes.shape(recipientPropType)),
  uniqueAlertCount: PropTypes.number,
  createdAt: PropTypes.number,
});

export default { notificationGroupPropType };
